import { TermReason } from "./types";

export const ALL_OPTIONS = "ALL";

export const reasonOptions: { label: string; value: TermReason }[] = [
  { label: "Todos", value: "ALL" },
  { label: "Férias", value: "FERIAS" },
  { label: "Troca de Gerente", value: "TROCA_GERENTE" },
  { label: "Atestado", value: "ATESTADO" },
  { label: "Desligamento", value: "DESLIGAMENTO" },
  { label: "Licença Maternidade", value: "LICENCA_MATERNIDADE" },
  { label: "Pedido de Demissão", value: "PEDIDO_DEMISSAO" },
];

export const statusOptions = [
  { value: "ALL", label: "Todos" },
  { value: "PENDING", label: "Pendente" },
  { value: "APPROVED", label: "Aprovado" },
  { value: "CANCELED", label: "Cancelado" },
  { value: "REJECTED", label: "Rejeitado" },
  { value: "TERM_SIGNED", label: "Assinado" },
  { value: "TERM_PENDING_SIGNATURE", label: "Assinatura Pendente" },
];
